import React from "react";

interface AnchorLinkI {
  data: {
    AnchorLinkId: string;
  };
}

const AnchorLink = ({ data }: AnchorLinkI) => {
  const { AnchorLinkId } = data;
  return <div id={AnchorLinkId} />;
};

export default AnchorLink;
